import request from "./request";
import { getConfig } from "@/utils/index";

/**获取app config */
export function getAllinfo() {
  return request({
    url: "/aa-sso-api/ext/app/https/appconfig/query?appId=1",
    method: "get",
  });
}

/**子账号注册接口（邮箱 主账号个人中心）新增企业成员（用于growth网站注册role=4的外部客户类型的账号） */
export function register(data) {
  return request({
    url: "/ext/user/for/growth/email/sub/account/register",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

/**登录 */
export function login(data) {
  return request({
    url: "/ext/user/email/login",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

/**退出登录 */
export function logout(data) {
  return request({
    url: "/ext/user/logout",
    method: "post",
    params: data,
    data,
    baseURL: getConfig("sso"),
  });
}

/**获取用户信息 */
export function getInfo(params) {
  return request({
    url: "/ext/user/detail/by/userid/query",
    method: "get",
    params,
    baseURL: getConfig("mainbiz"),
  });
}

/**获取注册验证码 */
export function getCaptcha(data) {
  return request({
    url: "/ext/user/captcha/by/email/register/apply",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

/**申请用于邮箱验证码修改密码的验证码 */
export function updatepasswordapply(data) {
  return request({
    url: "/ext/user/captcha/by/email/update/password/apply",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}

/**通过邮箱验证码方式的登录密码修改操作接口（邮箱） */
export function captchapasswordupdate(data) {
  return request({
    url: "/ext/user/by/email/captcha/password/update",
    method: "post",
    data,
    baseURL: getConfig("sso"),
  });
}
// 修改用户名称
export function nicknameUpdate(data) {
  return request({
    url: "ext/user/detail/user/nickname/update",
    method: "post",
    data,
    baseURL: getConfig("mainbiz"),
  });
}
// 修改用户头像
export function headSculUpdate(data) {
  return request({
    url: "/ext/user/detail/user/head/portrait/update",
    method: "post",
    data,
    baseURL: getConfig("mainbiz"),
  });
}

/**NocoDB登陆接口（邮箱） */
export function nocodbSignin(data) {
  return request({
    url: "/ext/user/detail/for/nocodb/sign",
    method: "post",
    data,
    baseURL: getConfig("mainbiz"),
    // baseURL: "http://192.168.101.192:9888/aa-mainbiz/aa-mainbiz-api/",
  });
}

/**baserow登陆接口（邮箱） */
export function baserowSignin(data) {
  return request({
    url: "/ext/user/detail/for/baserow/sign",
    method: "post",
    data,
    baseURL: getConfig("mainbiz"),
    // baseURL: "http://192.168.101.192:9888/aa-mainbiz/aa-mainbiz-api/",
  });
}
// 判断邀请链接是否失效（curl）
export function getIsExpiredCheck(params) {
  return request({
    url: "/ext/user/invitation/link/isExpired/check",
    method: "get",
    params,
    baseURL: getConfig("sso"),
  });
}
// 设置密码
export function initialPwdUpdate(data) {
  return request({
    url: "/ext/user/initial/password/update",
    method: "post",
    data: {},
    params: data,
    baseURL: getConfig("sso"),
  });
}

// 获取播放凭证
export function getPlayAuth(params: any) {
  return request({
    url: "/api/upload/videoPlayAuth",
    method: "get",
    params,
    baseURL: getConfig("mainbiz"),
  });
}
